/**
 * True while the page is being rendered by scripts/prerender.js (headless
 * Chromium at build time). The flag is set via page.evaluateOnNewDocument
 * before any app script runs, so it is safe to read during the first render.
 *
 * Use it for UI that must not end up in the prerendered HTML in an
 * "interactive" state, e.g. the cookie banner: the static HTML would otherwise
 * show it to visitors who already made a choice until React has hydrated.
 */
export const isPrerendering = () =>
  typeof window !== 'undefined' && window.__PRERENDER__ === true;
